import * as API from "./Api";

export const getUserDetails = () => API.get("user");
export const updateCreatorDetails = (data) => API.put("user/creator", data);
export const updateBrandDetails = (data) => API.put("user/brand", data);
